import { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import AgencyImg from '../../../../assets/images/agencies-header-image.webp';
import Flex from '../../Flex.tsx';
import SecondaryText from '../../../typography/SecondaryText.tsx';

type Props = {
  title?: string;
  description?: string;
};

const ImageBlock: FC<Props> = ({ title, description }) => {
  const { t } = useTranslation('component/auth_layout');

  return (
    <div
      className={classNames(
        'max-1024:hidden lg:block',
        '800:py-[24px] 800:pr-[24px] 800:pl-[4px] min-h-[500px] 800:h-full',
        '800:basis-[616px] 1440:basis-[686px] 1920:basis-[926px]',
      )}
    >
      <div className={classNames('relative h-full w-full')}>
        <img
          src={AgencyImg}
          alt="connected railway"
          className="h-full object-cover 800:rounded-[12px] relative z-0 bg-center"
        />

        <Flex.Wrapper
          column
          jEnd
          className={classNames(
            'absolute top-0 left-0 p-[24px] w-full h-full z-10 800:rounded-[12px]',
            'bg-gradient-to-b from-[black]/[0.16] to-[black]/40',
          )}
        >
          <h1
            className={classNames(
              'text-h1 text-white tablet:text-[52px] tablet:leading-[68px] font-lexend',
              'whitespace-pre-wrap ',
              'max-w-[500px] laptop:max-w-max',
            )}
          >
            {title || t('title')}
          </h1>

          <SecondaryText className="laptop:text-main mt-[8px] text-white whitespace-pre-wrap">
            {description || t('subtitle')}
          </SecondaryText>
        </Flex.Wrapper>
      </div>
    </div>
  );
};

export default ImageBlock;
